import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { groupBy } from 'lodash'
import moment from 'moment';

interface WarehouseDeliveryApproveListState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    days: any[];
    schema: any;

    meta: any;
}

const state: WarehouseDeliveryApproveListState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    days: [],
    schema: null,

    meta: {},
};

export const ITEMS_LIST = 'GET_WAREHOUSE_DELIVERY_APPROVE_LIST';

export const actions: ActionTree<WarehouseDeliveryApproveListState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "warehouse_name": "w.name",
                "deal_id": "d.id",
                "delivery_date": "d.availability_date",
                "availability_date": "d.availability_date",
                "delivery_approved_at": "d.delivery_approved_at",
                "total_quantity": "vdt.total_quantity",
                "total_weight": "vdt.total_weight"
            };

            const filter: any[] = [];
            filter.push({'$not': [{'$eq': ["d.status_id", {"$":"d:statuses:19"}]}]})
            // filter.push({"$eq": ["di.state", {"$": 'confirmed'}]})
            filter.push({"$in": ["d.type_id", {"$": ['d:deals_types:3', 'd:deals_types:4']}]})
            filter.push({
                "$or": [
                    {"$null": ["d.return_type_id"]},
                    {"$in": ["d.return_type_id", {"$": ['d:deals_return_types:2']}]}
                ]
            })
            filter.push({"$gte": ["d.availability_date", {"$": (query.since ? moment(query.since) : moment()).format('YYYY-MM-DD')}]})
            filter.push({"$lte": ["d.availability_date", {"$": (query.until ? moment(query.until) : moment()).format('YYYY-MM-DD')}] })

            if (query.client_id) {
                filter.push({"$eq": ["d.client_id", {"$": query.client_id}] })
            }
            // if (query.delivery_zone_id) {
            //     filter.push({"$eq": ["di.delivery_zone_id", {"$": query.delivery_zone_id}] })
            // }
            // if (query.delivery_zone_group_id) {
            //     filter.push({"$eq": ["dz.delivery_zone_group_id", {"$": query.delivery_zone_group_id}] })
            // }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:deals",
                    "from_as": "d",
                    "joins": [
                      {
                        "join": "s:delivery_instance_deals",
                        // "type": "inner",
                        "as":   "did",
                        "on": {
                          "$eq": ["did.deal_id", "d.id"]
                        }
                      },
                    //   {
                    //     "join": "s:delivery_instances",
                    //     // "type": "inner",
                    //     "as":   "di",
                    //     "on": {
                    //       "$eq": ["di.id", "did.delivery_instance_id"]
                    //     }
                    //   },
                    //   {
                    //     "join": "s:delivery_zones",
                    //     // "type": "inner",
                    //     "as":   "dz",
                    //     "on": {
                    //       "$eq": ["dz.id", "di.delivery_zone_id"]
                    //     }
                    //   },
                      {
                        "join": "s:clients",
                        // "type": "inner",
                        "as":   "c",
                        "on": {
                          "$and": [
                            {"$eq": ["d.client_id", "c.id"]},
                          ]
                        }
                      },
                      {
                        "join": "s:warehouses",
                        // "type": "inner",
                        "as":   "w",
                        "on": {
                          "$eq": ["d.destination_warehouse_id", "w.id"]
                        }
                      },
                      {
                        "join": "s:view_deals_totals_with_all_partners",
                        // "type": "inner",
                        "as":   "vdt",
                        "on": {
                          "$eq": ["vdt.id", "d.id"]
                        }
                      }
                    ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'asc' ? { $asc: [columns[query.sortField || 'warehouse_name' ]] } : { $desc: [columns[query.sortField || 'warehouse_name']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve(null);
            }));
        })
    },
    setDeliveryApprove({commit}, deal_id) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('deals_delivery_approve')
                .action({
                    deal_id: deal_id
                }),
            ]).then(((result: ServerResult) => {
                commit('LOADED_SUCCESS');

                resolve(null);
            }));
        });
    }

};

export const mutations: MutationTree<WarehouseDeliveryApproveListState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents

        state.schema = data.schema;
        state.meta = fetchEnumsFromSchema(data.schema);
        console.log(state.meta)

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_warehouses_delivery_approve_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
